import styled, {css} from 'styled-components'
import {Box, StyleProps} from '@miro-site/core'

interface CardProps {
  hasBorder?: boolean
  $styles?: StyleProps
  $isFocused?: boolean
}

const Card = styled(Box).attrs<CardProps>(({hasBorder = true, theme, $styles = {}}) => ({
  $styles: {
    borderRadius: 16,
    border: hasBorder ? `1px solid ${theme.colors.lightGray}` : '1px solid transparent',
    ...$styles,
  },
}))<CardProps>`
  ${({theme}) => css`
    ${theme.mq.small(css`
      box-shadow: 0 ${theme.multipliers.small(4)} ${theme.multipliers.small(12)}
        rgba(5, 0, 56, 0.08);
    `)}
    ${theme.mq.mediumDown(css`
      box-shadow: 0 ${theme.multipliers.mediumDown(4)} ${theme.multipliers.mediumDown(12)}
        rgba(5, 0, 56, 0.08);
    `)}
    ${theme.mq.mediumUp(css`
      box-shadow: 0 ${theme.multipliers.mediumUp(4)} ${theme.multipliers.mediumUp(12)}
        rgba(5, 0, 56, 0.08);
    `)}
    ${theme.mq.large(css`
      box-shadow: 0 ${theme.multipliers.large(4)} ${theme.multipliers.large(12)}
        rgba(5, 0, 56, 0.08);
    `)}
  `};

  ${({theme, $isFocused}) => $isFocused && theme.normalizeStyles(theme.focus.outlines.default)}
`

export default Card
